(function ( $ ) {

    $(document).on('ready', function () {

        var $header = $('.header');
        var $navMenu = $('#nav-menu');

        $('.menu-icon').on('click', function () {

            $(this).toggleClass('is-active').parent().toggleClass('active');
            $navMenu.toggleClass('menu-visible');
            $header.toggleClass('menu-expanded');
        });



        var $propertyTitleEffectTriggers = $('.property-js-effect'); // to add custom underline for Property Title
        if ( $propertyTitleEffectTriggers.length > 0 ) {
            $propertyTitleEffectTriggers.on('mouseover', function () {
                $(this).closest('.type-property').addClass('hovered');
            });

            $propertyTitleEffectTriggers.on('mouseleave', function () {
                $(this).closest('.type-property').removeClass('hovered');
            });
        }

        $('.footer__nav a[href="#"]').on('click', function (e) {
            e.preventDefault();
        });



    });

})( jQuery )